import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "top-tabs tabs-buttons" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["disabled", "title"]
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = ["disabled", "title"]

import { ref } from "vue";
import SubmitDrawdown from "./SubmitDrawdown.vue";
import ConfirmedDrawdown from "./ConfirmedDrawdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Drawdown',
  setup(__props) {

const showDrawdown = ref<boolean>(true);

function ToggleTabs() {
    showDrawdown.value = !showDrawdown.value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-left ${showDrawdown.value ? 'selected' : 'unselected'}`),
            disabled: showDrawdown.value,
            title: 
                        showDrawdown.value
                            ? 'Currently viewing the Form to submit Drawdowns'
                            : 'Click to view Confirmed Drawdowns'
                    ,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (ToggleTabs()))
          }, " Drawdown ", 10, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-right ${showDrawdown.value ? 'unselected' : 'selected'}`),
            disabled: !showDrawdown.value,
            title: 
                        !showDrawdown.value
                            ? 'Currently viewing Confirmed Drawdowns'
                            : 'Click to view the Form to submit Drawdowns'
                    ,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (ToggleTabs()))
          }, " Confirmed ", 10, _hoisted_6)
        ])
      ])
    ]),
    (showDrawdown.value)
      ? (_openBlock(), _createBlock(SubmitDrawdown, { key: 0 }))
      : _createCommentVNode("", true),
    (!showDrawdown.value)
      ? (_openBlock(), _createBlock(ConfirmedDrawdown, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})